import { useState } from 'react';
import { CheckboxInput } from './Styled';

interface CheckBoxProps {
  id: string;
  name?: string;
  checked?: boolean;
  label: string;
  className?: string;
  compact?: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function CheckBox({
  id,
  className,
  checked,
  name,
  label,
  compact = false,
  handleChange
}: CheckBoxProps) {
  const [isChecked, setIsChecked] = useState(checked);
  const compactClassNames = compact
    ? 'flex items-center space-x-3'
    : 'grid grid-cols-12 items-center my-8';

  function handleCheckboxChange(event: React.ChangeEvent<HTMLInputElement>) {
    setIsChecked(event.target.checked);
    handleChange(event);
  }

  return (
    <div
      className={`${compactClassNames} ${className || ''}`}
      aria-live="assertive"
    >
      <div className="col-span-1">
        <CheckboxInput
          type="checkbox"
          id={id}
          name={name}
          checked={isChecked}
          onChange={e => handleCheckboxChange(e)}
        />
      </div>
      <div className="col-span-11 ml-4 md:ml-0">
        <label htmlFor={id}>{label}</label>
      </div>
    </div>
  );
}

export default CheckBox;
